import { useNavigate } from "react-router-dom";
import withLoader from "../../components/layouts/WithLoader";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import TierAccountService from "../../services/PayementSolde/TierAccountService";
import CardSolde from "./Solde/CardSolde";
import { useEffect, useState } from "react";
import SocieteService from "../../services/Societe";
import makeAnimated from "react-select/animated";
import Select from "react-select";

const ClientWalletAndSolde = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [societes, setSocietes] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [idSociete, setIdSociete] = useState(null);
  const [btnSoldeClicked, setBtnSoldeClicked] = useState(false);
  const [soldeInfo, setSoldeInfo] = useState(null);
  const [walletInfo, setWalletInfo] = useState(null);
  const [tier, setTier] = useState(null);

  const animatedComponents = makeAnimated();

  useEffect(() => {
    setOptions([]);
    startLoading();
    SocieteService.getSocietesClients("CLIENT", "CLIENT", 1, 0)
      .then((response) => {
        if (response.data["vide"] !== undefined) {
          setAlertMessage("error");
        } else {
          localStorage.setItem("TypeTiersAccount", "C");

          setSocietes(response.data["Societe"]);
          setAlertMessage("success");
          const newOptions = response.data["Societe"].map((typeBill) => ({
            value: typeBill.id,
            label: typeBill.title,
          }));
          console.log("newOptions", newOptions);
          setOptions((prevOptions) => [...prevOptions, ...newOptions]);
        }
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);

    setIdSociete(selectedOption.value);
  };
  const saveIdSociete = (e) => {
    startLoading();

    TierAccountService.getSoldeAndWalletById(getCurrentUserId(), idSociete)
      .then((response) => {
        setSoldeInfo(response.data.solde);
        setWalletInfo(response.data.wallet);
        setTier(response.data.tiers);

        setBtnSoldeClicked(true);
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const detailsSolde = (id) => {
    localStorage.setItem("idAccountSolde",id)
      navigate(`/detailsTransactionAccountClient`);

    
  };
  const resultSolde = () => {
    if (btnSoldeClicked) {
      if (
        soldeInfo !== null &&
        soldeInfo !== undefined &&
        walletInfo !== null &&
        walletInfo !== undefined
      ) {
        return (
          <div className="row">
            {soldeInfo && (
              <div className="col-md-6 col-sm-6 col-12">
                <div className="info-box bg-gray ">
                  <span className="info-box-icon">
                    <i class="fas fa-dollar-sign"></i>{" "}
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Solde client</span>
                    <span className="info-box-number">{soldeInfo.title}</span>
                    <div className="progress">
                      <div className="progress-bar" style={{ width: "70%" }} />
                    </div>
                    <span className="progress-description">
                      {soldeInfo.solde}{" "}
                      <button
                        style={{ width: 40 }}
                        class="btn bg-gray-dark btn-sm float-right"
                        onClick={(e) => detailsSolde(soldeInfo?.id)}
                      >
                        <i class="fas fa-eye"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            )}
            {walletInfo && (
              <div className="col-md-6 col-sm-6 col-12">
                <div className="info-box bg-gray-dark">
                  <span className="info-box-icon">
                    <i class="fas fa-dollar-sign"></i>{" "}
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Wallet client</span>
                    <span className="info-box-number">{walletInfo.title}</span>
                    <div className="progress">
                      <div className="progress-bar" style={{ width: "70%" }} />
                    </div>
                    <span className="progress-description">
                      {walletInfo.solde}
                      <button
                        style={{ width: 40 }}
                        class="btn bg-gray btn-sm float-right"
                        onClick={(e) => detailsSolde(walletInfo?.id)}
                      >
                         <i class="fas fa-eye"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      }
    }
  };

  const resultTiers = () => {
    if (btnSoldeClicked) {
      if (tier !== null && tier !== undefined) {
        return (
          <div class="card  mt-3">
            {tier && (
              <div class="card-body">
                <h4 class="card-title">La société : {tier?.title} </h4>
                <br />
                <br />
                <>
                  <p>
                    Matricule :{tier.matricule} / {tier.codeCategorie} /{" "}
                    {tier.codeTVA} / {tier.numberEtabSecondaire}
                  </p>
                  <p>Adresse :{tier.adresse}</p>
                </>
              </div>
            )}
          </div>
        );
      }
    }
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <br />
      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <div className="card card-dark">
              <div className="card-header">
                <h3 className="card-title">Les Soldes des clients</h3>
              </div>
              <form
                className="form-horizontal"
                // onSubmit={saveIdSociete}
              ></form>
              {/* /.card-header */}
              <div className="card-body">
                <div class="row">
                  <div class="form-group col-4 col-sm-4">
                    <div>
                      <label>Choisir les clients</label>
                      <Select
                        value={selectedOption}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        options={options}
                        onChange={handleChange}
                        // defaultValue={selectedOption}
                        placeholder={"Tous"}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <button
                  type="submit"
                  onClick={saveIdSociete}
                  className="btn btn-dark float-right "
                >
                  Valider
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="content">
        <div class="row">
          <div class="col-md-12">{resultTiers()}</div>
        </div>
      </section>
      <section class="content">
        <div class="row">
          <div class="col-md-12">{resultSolde()}</div>
        </div>
      </section>
    </div>
  );
};
export default withLoader(ClientWalletAndSolde);
